import Component from "@glimmer/component";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { service } from "@ember/service";
import TopicBulkActions from "discourse/components/modal/topic-bulk-actions";
import NewListHeaderControls from "discourse/components/topic-list/new-list-header-controls";
import TopicBulkSelectDropdown from "discourse/components/topic-list/topic-bulk-select-dropdown";
import concatClass from "discourse/helpers/concat-class";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
export default class TopicListHeaderColumn extends Component {
  static #_ = (() => dt7948.g(this.prototype, "modal", [service]))();
  #modal = (() => (dt7948.i(this, "modal"), void 0))();
  static #_2 = (() => dt7948.g(this.prototype, "router", [service]))();
  #router = (() => (dt7948.i(this, "router"), void 0))();
  get localizedName() {
    if (this.args.forceName) {
      return this.args.forceName;
    }
    return this.args.name ? i18n(this.args.name) : "";
  }
  get isSorting() {
    return this.args.sortable && this.args.order === this.args.activeOrder;
  }
  get ariaSort() {
    if (this.isSorting) {
      return this.args.ascending ? "ascending" : "descending";
    }
  }
  // TODO: this code probably shouldn't be in all columns
  bulkSelectAll() {
    this.args.bulkSelectHelper.autoAddTopicsToBulkSelect = true;
    document.querySelectorAll("input.bulk-select:not(:checked)").forEach(el1 => el1.click());
  }
  static #_3 = (() => dt7948.n(this.prototype, "bulkSelectAll", [action]))();
  bulkClearAll() {
    this.args.bulkSelectHelper.autoAddTopicsToBulkSelect = false;
    document.querySelectorAll("input.bulk-select:checked").forEach(el1 => el1.click());
  }
  static #_4 = (() => dt7948.n(this.prototype, "bulkClearAll", [action]))();
  bulkSelectActions() {
    this.modal.show(TopicBulkActions, {
      model: {
        topics: this.args.bulkSelectHelper.selected,
        category: this.category,
        refreshClosure: () => this.router.refresh()
      }
    });
  }
  static #_5 = (() => dt7948.n(this.prototype, "bulkSelectActions", [action]))();
  onClick() {
    this.args.changeSort(this.args.order);
  }
  static #_6 = (() => dt7948.n(this.prototype, "onClick", [action]))();
  onKeyDown(event1) {
    if (event1.key === "Enter" || event1.key === " ") {
      this.args.changeSort(this.args.order);
      event1.preventDefault();
    }
  }
  static #_7 = (() => dt7948.n(this.prototype, "onKeyDown", [action]))();
  afterBulkActionComplete() {
    return this.router.refresh();
  }
  static #_8 = (() => dt7948.n(this.prototype, "afterBulkActionComplete", [action]))();
  static #_9 = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      <th
        {{(if @sortable (modifier on "click" this.onClick))}}
        {{(if @sortable (modifier on "keydown" this.onKeyDown))}}
        data-sort-order={{@order}}
        scope="col"
        tabindex={{if @sortable "0"}}
        role={{if @sortable "button"}}
        aria-pressed={{this.isSorting}}
        aria-sort={{this.ariaSort}}
        class={{concatClass
          "topic-list-data"
          @order
          (if @sortable "sortable")
          (if @isSorting "sorting")
          (if @number "num")
        }}
        ...attributes
      >
        {{#if @canBulkSelect}}
          {{#if @showBulkToggle}}
            <button
              {{on "click" @bulkSelectHelper.toggleBulkSelect}}
              title={{i18n "topics.bulk.toggle"}}
              class="btn-flat bulk-select"
            >
              {{icon (if @experimentalTopicBulkActionsEnabled "tasks" "list")}}
            </button>
          {{/if}}
  
          {{#if @bulkSelectEnabled}}
            <span class="bulk-select-topics">
              {{#if @canDoBulkActions}}
                {{#if @experimentalTopicBulkActionsEnabled}}
                  <TopicBulkSelectDropdown
                    @bulkSelectHelper={{@bulkSelectHelper}}
                    @afterBulkActionComplete={{this.afterBulkActionComplete}}
                  />
                {{else}}
                  <button
                    {{on "click" this.bulkSelectActions}}
                    class="btn btn-icon no-text bulk-select-actions"
                  >{{icon "cog"}}&#8203;</button>
                {{/if}}
              {{/if}}
  
              <button
                {{on "click" this.bulkSelectAll}}
                class="btn btn-default bulk-select-all"
              >{{i18n "topics.bulk.select_all"}}</button>
              <button
                {{on "click" this.bulkClearAll}}
                class="btn btn-default bulk-clear-all"
              >{{i18n "topics.bulk.clear_all"}}</button>
            </span>
          {{/if}}
        {{/if}}
  
        {{#unless @bulkSelectEnabled}}
          {{#if @showTopicsAndRepliesToggle}}
            <NewListHeaderControls
              @current={{@newListSubset}}
              @newRepliesCount={{@newRepliesCount}}
              @newTopicsCount={{@newTopicsCount}}
              @changeNewListSubset={{@changeNewListSubset}}
            />
          {{else}}
            <span>{{this.localizedName}}</span>
          {{/if}}
        {{/unless}}
  
        {{#if this.isSorting}}
          {{icon (if @ascending "chevron-up" "chevron-down")}}
        {{/if}}
      </th>
    
  */
  {
    "id": "uwuxsNsb",
    "block": "[[[1,\"\\n    \"],[11,\"th\"],[16,\"data-sort-order\",[30,1]],[24,\"scope\",\"col\"],[16,\"tabindex\",[52,[30,2],\"0\"]],[16,\"role\",[52,[30,2],\"button\"]],[16,\"aria-pressed\",[30,0,[\"isSorting\"]]],[16,\"aria-sort\",[30,0,[\"ariaSort\"]]],[16,0,[28,[32,0],[\"topic-list-data\",[30,1],[52,[30,2],\"sortable\"],[52,[30,3],\"sorting\"],[52,[30,4],\"num\"]],null]],[17,5],[4,[52,[30,2],[50,[32,1],2,[\"click\",[30,0,[\"onClick\"]]],null]],null,null],[4,[52,[30,2],[50,[32,1],2,[\"keydown\",[30,0,[\"onKeyDown\"]]],null]],null,null],[12],[1,\"\\n\"],[41,[30,6],[[[41,[30,7],[[[1,\"          \"],[11,\"button\"],[16,\"title\",[28,[32,2],[\"topics.bulk.toggle\"],null]],[24,0,\"btn-flat bulk-select\"],[4,[32,1],[\"click\",[30,8,[\"toggleBulkSelect\"]]],null],[12],[1,\"\\n            \"],[1,[28,[32,3],[[52,[30,9],\"tasks\",\"list\"]],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,10],[[[1,\"          \"],[10,1],[14,0,\"bulk-select-topics\"],[12],[1,\"\\n\"],[41,[30,11],[[[41,[30,9],[[[1,\"                \"],[8,[32,4],null,[[\"@bulkSelectHelper\",\"@afterBulkActionComplete\"],[[30,8],[30,0,[\"afterBulkActionComplete\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"                \"],[11,\"button\"],[24,0,\"btn btn-icon no-text bulk-select-actions\"],[4,[32,1],[\"click\",[30,0,[\"bulkSelectActions\"]]],null],[12],[1,[28,[32,3],[\"cog\"],null]],[1,\"​\"],[13],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n            \"],[11,\"button\"],[24,0,\"btn btn-default bulk-select-all\"],[4,[32,1],[\"click\",[30,0,[\"bulkSelectAll\"]]],null],[12],[1,[28,[32,2],[\"topics.bulk.select_all\"],null]],[13],[1,\"\\n            \"],[11,\"button\"],[24,0,\"btn btn-default bulk-clear-all\"],[4,[32,1],[\"click\",[30,0,[\"bulkClearAll\"]]],null],[12],[1,[28,[32,2],[\"topics.bulk.clear_all\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n\"],[41,[51,[30,10]],[[[41,[30,12],[[[1,\"          \"],[8,[32,5],null,[[\"@current\",\"@newRepliesCount\",\"@newTopicsCount\",\"@changeNewListSubset\"],[[30,13],[30,14],[30,15],[30,16]]],null],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,1],[12],[1,[30,0,[\"localizedName\"]]],[13],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n\"],[41,[30,0,[\"isSorting\"]],[[[1,\"        \"],[1,[28,[32,3],[[52,[30,17],\"chevron-up\",\"chevron-down\"]],null]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"]],[\"@order\",\"@sortable\",\"@isSorting\",\"@number\",\"&attrs\",\"@canBulkSelect\",\"@showBulkToggle\",\"@bulkSelectHelper\",\"@experimentalTopicBulkActionsEnabled\",\"@bulkSelectEnabled\",\"@canDoBulkActions\",\"@showTopicsAndRepliesToggle\",\"@newListSubset\",\"@newRepliesCount\",\"@newTopicsCount\",\"@changeNewListSubset\",\"@ascending\"],false,[\"if\",\"modifier\",\"unless\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/topic-list/topic-list-header-column.js",
    "scope": () => [concatClass, on, i18n, icon, TopicBulkSelectDropdown, NewListHeaderControls],
    "isStrictMode": true
  }), this))();
}